export const FETCH_KNOWLEDGE_QUESTION_SET = 'FETCH_KNOWLEDGE_QUESTION_SET'
export const FETCH_KNOWLEDGE_QUESTION_SET_SUCCESS = `${FETCH_KNOWLEDGE_QUESTION_SET}_SUCCESS`

export const FETCH_KNOWLEDGE_QUESTION_SET_LOGS = 'FETCH_KNOWLEDGE_QUESTION_SET_LOGS'
export const FETCH_KNOWLEDGE_QUESTION_SET_LOGS_SUCCESS = `${FETCH_KNOWLEDGE_QUESTION_SET_LOGS}_SUCCESS`

export const FETCH_KNOWLEDGE_QUESTION_SET_EVENT_TYPES = 'FETCH_KNOWLEDGE_QUESTION_SET_EVENT_TYPES'
export const FETCH_KNOWLEDGE_QUESTION_SET_EVENT_TYPES_SUCCESS = `${FETCH_KNOWLEDGE_QUESTION_SET_EVENT_TYPES}_SUCCESS`
